/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ naam: NonNullable<unknown> }} Planning_Vakanties_AanpassenInputs */

const nl_planning_vakanties_aanpassen = /** @type {(inputs: Planning_Vakanties_AanpassenInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.naam} aanpassen`)
};

/**

* @param {Planning_Vakanties_AanpassenInputs} inputs
* @param {{ locale?: "nl" }} options
* @returns {LocalizedString}
*/
const planning_vakanties_aanpassen = /** @type {((inputs: Planning_Vakanties_AanpassenInputs, options?: { locale?: "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Planning_Vakanties_AanpassenInputs, { locale?: "nl" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return nl_planning_vakanties_aanpassen(inputs)
});
export { planning_vakanties_aanpassen as "planning.vakanties.aanpassen" }